<!-- eslint-disable prettier/prettier -->
<style lang="scss">
@import '../assets/sass/abstracts/_variables.scss';

	div#watercourse-page {
		position: absolute;
		right: 30px;
		top: 86px;
		background: #ffffff;
		-webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
		box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
		width: 100%;
		max-width: 580px;
		min-height: 200px;
		padding: 20px;
		padding-top: 10px;
		z-index: 401;
    font-size: 14px;
    overflow-y: auto;

		img.close-icon {
			float: right;
			cursor: pointer;
			margin-top: 10px;
		}

		.county-watercoursenumber {
			color: $nina-darkgray;

			span {
				text-transform: uppercase;
				font-size: 12px;
				padding: 4px 5px 0 0;
			}
		}

		label.watercourse-label {
			font-family: Lato, sans-serif;
			text-transform: uppercase;
			font-weight: 700;
			color: #000;
			margin-top: 20px;
			margin-bottom: 10px;
		}


		.laksefjord {
			color: #000;
			font-family: Lato, sans-serif;
      background-color: $nina-gray;
      margin: 0.6em 0
		}

		.status-container {
			color: $nina-darkgray;
      margin-top: 0.3em;
		}

		div.location-filter-container {
			margin: 10px 0 20px 0;
		}

		div.location-filter {
			text-align: center;
			font-family: 'Lato', sans-serif;
			font-size: 16px;
			color: $nina-darkgray;
			border-bottom: 1px solid $nina-darkgray;
			border-top: 1px solid $nina-darkgray;
			border-left: 1px solid $nina-darkgray;
			border-right: 1px solid $nina-darkgray;
			width: 50%;
			display: inline-block;
			height: 45px;
			line-height: 45px;
			cursor: pointer;
			margin-bottom: 5px;

			&.active {
				color: white;
				background-color: $nina-darkgray;
			}

			&.kvalitetsnorm {
				border-top-left-radius: 3px;
				border-bottom-left-radius: 3px;
			}

			&.nyeste {
				border-top-right-radius: 3px;
				border-bottom-right-radius: 3px;
			}
		}

		.medium-top-margin {
			margin-top: 20px;
		}

		.circle {
			height: 25px;
			width: 25px;
			margin-right: 10px;
		}
	}

/* Small only */
@media screen and (max-width: 39.9375em) {
  div#watercourse-page {
    position: fixed;
    right: 0px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    z-index: 99999;
  }
}

/* Medium only */
@media screen and (min-width: 40em) and (max-width: 63.9375em) {
}

/* Large only */
@media screen and (min-width: 64em) and (max-width: 74.9375em) {
}
</style>

<template>
  <div id="watercourse-page" v-show="watercourseLoadStatus === 2">
    <a v-on:click="leaveWatercourse()">
      <img class="close-icon" src="../assets/img/close-icon.svg" />
    </a>

    <div class="watercourse-container">
      <h1 class="h1-custom">{{ watercourse.name }}</h1>
      <div class="county-watercoursenumber">
        <span>Fylke:</span>
        {{ watercourse.county }}
        <span>Vassdragsnr:</span>
        {{ watercourse.watercourseNumber }}
      </div>
      <span class="label laksefjord" v-if="watercourse.nationalSalmonWatercourse">Nasjonal laksefjord</span>
      
      <div class="no-data" v-show="!hasData">
        <div class="grid-x">
          <div class="large-12 medium-12 small-12 cell">
            <div class="status-container">
              <span v-bind:class="[status]"></span>
              <span>{{ statusText }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="watercourse-data" v-show="hasData">
        <div class="grid-x">
          <div class="large-12 medium-12 small-12 cell">
            <div class="status-container">
              <span v-bind:class="[status]"></span>
              <span>{{ statusText }}</span>
              <p><em v-show="watercourse.comment">I følgende prøver: {{ watercourse.comment }}</em></p>
            </div>
           
          </div>
        </div>

        <div class="grid-x">
          <div class="large-12 medium-12 small-12 cell centered">
            <watercourse-table></watercourse-table>
            <!-- <watercourse-graph></watercourse-graph> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import router from '../router.js';
import WatercourseTable from '../components/WatercourseTable.vue';
// import WatercourseGraph from '../components/WatercourseGraph.vue';

export default {
  data() {
    return {
      //activeView2: 'graph',
    };
  },
  components: {
    WatercourseTable
    // WatercourseGraph
  },
  created() {
    this.$store.dispatch('loadWatercourse', { id: this.$route.params.id });
  },
  computed: {
    watercourseLoadStatus() {
      return this.$store.getters.getWatercourseLoadStatus;
    },
    watercourse() {
      return this.$store.getters.getWatercourse;
    },
    // activeView() {
    //   return this.$store.getters.getView;
    // },
    hasData() {
      if (this.watercourseLoadStatus === 2) {
        return this.$store.getters.getWatercourse.watercourseResults.length > 0;
      }
      return false;
    },
    location() {
      if (this.watercourseLoadStatus === 2) {
        if (this.$store.getters.getWatercourse.watercourseResults.length > 0) {
          return this.$store.getters.getWatercourse.watercourseResults[0]
            .location;
        }
        return '';
      }
      return '';
    },
    status() {
      if (this.watercourseLoadStatus === 2) {        
          var status = this.$store.getters.getWatercourse.status;
          if (status === 1) {
            return 'circle green';
          } else if (status === 2) {
            return 'circle yellow';
          } else if (status === 3) {
            return 'circle orange';
          } else if (status === 4) {
            return 'circle red';
          } else if (status === 5) {
            return 'circle white'
          }
          return 'circle small darkgray';

      } else {
        //TODO: Blir dette rett?
        return null;
      }
    },
    statusText() {
      if (this.watercourseLoadStatus === 2) {
        if (this.$store.getters.getView === 'nyeste') {
          return (
            Math.round(
              this.$store.getters.getWatercourse.estimatedResult * 100
            ) +
            '% estimert genetisk påvirkning av rømt oppdrettslaks på villaksen'
          );
        } else {
          var status = this.$store.getters.getWatercourse.status;
          if (status === 1) {
            return 'Ingen genetiske endringer observert';
          } else if (status === 2) {
            return 'Genetiske endringer indikert';
          } else if (status === 3) {
            return 'Moderate genetiske endringer påvist';
          } else if (status === 4) {
            return 'Store genetiske endringer påvist';
          }
          else if (status === 5) {
            return 'Usikker tilstand. For få eller gamle data'
          }
          return 'Ingen data for dette vassdraget';
        }
      } else {
        //TODO: Blir dette rett?
        return null;
      }
    },
  },
  methods: {
    leaveWatercourse() {
      let prevLat = this.$store.getters.getLat;
      let prevLng = this.$store.getters.getLng;
      let prevZoom = this.$store.getters.getZoomLevel;
      EventBus.$emit('leave-watercourse', {
        zoom: prevZoom,
        lat: prevLat,
        lng: prevLng,
      });
      router.push({ name: 'watercourses' });
    },
  },
  watch: {
    watercourseLoadStatus: function (newValue) {
      /** Zoom */
      if (newValue == 2) {
        EventBus.$emit('location-selected', {
          lat: parseFloat(this.watercourse.latitude),
          lng: parseFloat(this.watercourse.longitude),
        });
      }
      if (newValue == 3) {
        EventBus.$emit('show-error', {
          notification: 'Klarte ikke å laste vassdraget',
        });
        this.$router.push({ name: 'watercourse' });
      }
    },
  },
};
</script>
